/**Constants in pricing */
export const FLOORING_PSF = "5.00";

let exterior = [
  {
    size: "eight",
    data: {
      back: [
        {
          image: "/B_22s_w_44s",
        },
        {
          image: "/B_22s_w_s_w",
        },
        {
          image: "/B_22s_w_w_s",
        },
        {
          image: "/B_22w_44w_22w",
        },
        {
          image: "/B_22w_s_44s",
        },
        {
          image: "/B_22w_s_44w",
        },
        {
          image: "/B_22w_s_w_s",
        },
        {
          image: "/B_22w_w_44w",
        },
        {
          image: "/B_44s_22s_w",
        },
        {
          image: "/B_44s_s",
        },
        {
          image: "/B_44s_w",
        },
        {
          image: "/B_44w_22s_w",
        },
        {
          image: "/B_44w_22w_w",
        },
        {
          image: "/B_44w_s",
        },
      ],
      front: [
        {
          image: "/F_22s_door",
        },
        {
          image: "/F_22w_door",
        },
        {
          image: "/F_door_22s",
        },
        {
          image: "/F_door_22w",
        },
        {
          image: "/F_22s_w_44s",
        },
        {
          image: "/F_22s_w_s_w",
        },
        {
          image: "/F_22s_w_w_s",
        },
        {
          image: "/F_22w_44s_22w",
        },
        {
          image: "/F_22w_44w_22w",
        },
        {
          image: "/F_22w_s_44s",
        },
        {
          image: "/F_22w_s_44w",
        },
        {
          image: "/F_22w_s_w_s",
        },
        {
          image: "/F_22w_w_44w",
        },
        {
          image: "/F_44s_22s_w",
        },
        {
          image: "/F_44s_22w_s",
        },
        {
          image: "/F_44s_s",
        },
        {
          image: "/F_44s_w",
        },
        {
          image: "/F_44w_22s_w",
        },
        {
          image: "/F_44w_22w_w",
        },
        {
          image: "/F_44w_s",
        },
      ],
      left: [
        {
          image: "/L_22s_door",
        },
        {
          image: "/L_22w_door",
        },
        {
          image: "/L_door_22s",
        },
        {
          image: "/L_door_22w",
        },
        {
          image: "/L_22s_w_44s",
        },
        {
          image: "/L_22s_w_s_w",
        },
        {
          image: "/L_22s_w_w_s",
        },
        {
          image: "/L_22w_44s_22w",
        },
        {
          image: "/L_22w_44w_22w",
        },
        {
          image: "/L_22w_s_44s",
        },
        {
          image: "/L_22w_s_44w",
        },
        {
          image: "/L_22w_s_w_s",
        },
        {
          image: "/L_22w_w_44w",
        },
        {
          image: "/L_44s_22s_w",
        },
        {
          image: "/L_44s_22w_s",
        },
        {
          image: "/L_44s_s",
        },
        {
          image: "/L_44s_w",
        },
        {
          image: "/L_44w_22s_w",
        },
        {
          image: "/L_44w_22w_w",
        },
        {
          image: "/L_44w_s",
        },
      ],
      right: [
        {
          image: "/R_22s_door",
        },
        {
          image: "/R_22w_door",
        },
        {
          image: "/R_door_22s",
        },
        {
          image: "/R_door_22w",
        },
        {
          image: "/R_22s_w_44s",
        },
        {
          image: "/R_22s_w_s_w",
        },
        {
          image: "/R_22s_w_w_s",
        },
        {
          image: "/R_22w_44s_22w",
        },
        {
          image: "/R_22w_s_44s",
        },
        {
          image: "/R_22w_s_44w",
        },
        {
          image: "/R_22w_s_w_s",
        },
        {
          image: "/R_22w_w_44w",
        },
        {
          image: "/R_44s_22s_w",
        },
        {
          image: "/R_44s_22w_s",
        },
        {
          image: "/R_44s_s",
        },
        {
          image: "/R_44s_w",
        },
        {
          image: "/R_44w_22s_w",
        },
        {
          image: "/R_44w_22w_w",
        },
        {
          image: "/R_44w_s",
        },
      ],
    },
  },
  {
    size: "ten",
    data: {
      back: [
        {
          image: "/B_22s_w_s_44s",
        },
        {
          image: "/B_22s_w_s_w_s",
        },
        {
          image: "/B_22w_44s_s",
        },
        {
          image: "/B_22w_s_w_s_w",
        },
        {
          image: "/B_22w_w_s_44s",
        },
        {
          image: "/B_44s_22s_44s",
        },
        {
          image: "/B_44s_22s_44w",
        },
        {
          image: "/B_44s_22s_w_s",
        },
        {
          image: "/B_44s_22s_w_w",
        },
        {
          image: "/B_44s_22w_44s",
        },
        {
          image: "/B_44s_22w_44w",
        },
        {
          image: "/B_44s_s_22w",
        },
        {
          image: "/B_44w_22s_44s",
        },
        {
          image: "/B_44w_22s_44w",
        },
        {
          image: "/B_44w_22w_44s",
        },
        {
          image: "/B_44w_22w_44w",
        },
      ],
      front: [
        {
          image: "/F_22s_door_22s",
        },
        {
          image: "/F_22s_door_22w",
        },
        {
          image: "/F_22s_w_door",
        },
        {
          image: "/F_22w_door_22s",
        },
        {
          image: "/F_22w_door_22w",
        },
        {
          image: "/F_22w_s_door",
        },
        {
          image: "/F_22w_w_door",
        },
        {
          image: "/F_44s_door",
        },
        {
          image: "/F_44w_door",
        },
        {
          image: "/F_door_22s_w",
        },
        {
          image: "/F_door_22w_s",
        },
        {
          image: "/F_door_22w_w",
        },
        {
          image: "/F_door_44s",
        },
        {
          image: "/F_door_44w",
        },
        {
          image: "/F_22s_w_s_44s",
        },
        {
          image: "/F_22s_w_s_w_s",
        },
        {
          image: "/F_22w_44s_s",
        },
        {
          image: "/F_22w_s_w_s_w",
        },
        {
          image: "/F_22w_w_s_44s",
        },
        {
          image: "/F_44s_22s_44s",
        },
        {
          image: "/F_44s_22s_44w",
        },
        {
          image: "/F_44s_22s_w_s",
        },
        {
          image: "/F_44s_22s_w_w",
        },
        {
          image: "/F_44s_22w_44s",
        },
        {
          image: "/F_44s_22w_44w",
        },
        {
          image: "/F_44s_s_22w",
        },
        {
          image: "/F_44w_22s_44s",
        },
        {
          image: "/F_44w_22s_44w",
        },
        {
          image: "/F_44w_22w_44s",
        },
        {
          image: "/F_44w_22w_44w",
        },
      ],
      left: [
        {
          image: "/L_22s_door",
        },
        {
          image: "/L_22w_door",
        },
        {
          image: "/L_door_22s",
        },
        {
          image: "/L_door_22w",
        },
        {
          image: "/L_22s_44w_22s",
        },
        {
          image: "/L_22s_w_44s",
        },
        {
          image: "/L_22s_w_s_w",
        },
        {
          image: "/L_22s_w_w_s",
        },
        {
          image: "/L_22w_44s_22w",
        },
        {
          image: "/L_22w_44w_22w",
        },
        {
          image: "/L_22w_s_44s",
        },
        {
          image: "/L_22w_s_44w",
        },
        {
          image: "/L_22w_s_w_s",
        },
        {
          image: "/L_22w_w_44w",
        },
        {
          image: "/L_44s_22s_w",
        },
        {
          image: "/L_44s_22w_s",
        },
        {
          image: "/L_44s_s",
        },
        {
          image: "/L_44s_w",
        },
        {
          image: "/L_44w_22s_w",
        },
        {
          image: "/L_44w_22w_w",
        },
        {
          image: "/L_44w_s",
        },
        {
          image: "/L_44w_w",
        },
      ],
      right: [
        {
          image: "/R_22s_door",
        },
        {
          image: "/R_22w_door",
        },
        {
          image: "/R_door_22s",
        },
        {
          image: "/R_door_22w",
        },
        {
          image: "/R_22s_44w_22s",
        },
        {
          image: "/R_22s_w_44s",
        },
        {
          image: "/R_22s_w_s_w",
        },
        {
          image: "/R_22s_w_w_s",
        },
        {
          image: "/R_22w_44s_22w",
        },
        {
          image: "/R_22w_44w_22w",
        },
        {
          image: "/R_22w_s_44s",
        },
        {
          image: "/R_22w_s_44w",
        },
        {
          image: "/R_22w_s_w_s",
        },
        {
          image: "/R_22w_w_44w",
        },
        {
          image: "/R_44s_22s_w",
        },
        {
          image: "/R_44s_22w_s",
        },
        {
          image: "/R_44s_s",
        },
        {
          image: "/R_44s_w",
        },
        {
          image: "/R_44w_22s_w",
        },
        {
          image: "/R_44w_22w_w",
        },
        {
          image: "/R_44w_s",
        },
        {
          image: "/R_44w_w",
        },
      ],
    },
  },
  {
    size: "twelve",
    data: {
      back: [
        {
          image: "/B_22s_w_w_w_w_s",
        },
        {
          image: "/B_22w_s_44s_s",
        },
        {
          image: "/B_22w_s_44w_22s_w",
        },
        {
          image: "/B_22w_w_44s_s",
        },
        {
          image: "/B_44s_22w_w_44s",
        },
        {
          image: "/B_44s_s_22s_w",
        },
        {
          image: "/B_44s_s_22w_w",
        },
        {
          image: "/B_44s_s_s",
        },
        {
          image: "/B_44s_s_w",
        },
        {
          image: "/B_44s_w_s",
        },
        {
          image: "/B_44s_w_w",
        },
        {
          image: "/B_44w_s_s",
        },
        {
          image: "/B_44w_s_w",
        },
        {
          image: "/B_44w_w_s",
        },
        {
          image: "/B_44w_w_w",
        },
      ],
      front: [
        {
          image: "/F_22s_11s_door_11s_22s",
        },
        {
          image: "/F_22s_11s_door_11s_22w",
        },
        {
          image: "/F_22s_door_44s",
        },
        {
          image: "/F_22w_11s_door_11s_22s",
        },
        {
          image: "/F_22w_11s_door_11s_22w",
        },
        {
          image: "/F_22w_44s_door",
        },
        {
          image: "/F_22w_door_22s_w",
        },
        {
          image: "/F_22w_door_44s",
        },
        {
          image: "/F_22w_door_44w",
        },
        {
          image: "/F_22w_s_door_22w",
        },
        {
          image: "/F_44s_22s_door",
        },
        {
          image: "/F_44s_22w_door",
        },
        {
          image: "/F_44s_door_22s",
        },
        {
          image: "/F_44s_door_22w",
        },
        {
          image: "/F_44w_22s_door",
        },
        {
          image: "/F_44w_door_22w",
        },
        {
          image: "/F_door_22s_44s",
        },
        {
          image: "/F_door_22s_44w",
        },
        {
          image: "/F_door_22w_44s",
        },
        {
          image: "/F_door_44s_22w",
        },
        {
          image: "/F_22s_w_w_w_w_s",
        },
        {
          image: "/F_22w_s_44s_s",
        },
        {
          image: "/F_22w_s_44w_22s_w",
        },
        {
          image: "/F_22w_w_44s_s",
        },
        {
          image: "/F_44s_22w_w_44s",
        },
        {
          image: "/F_44s_s_22s_w",
        },
        {
          image: "/F_44s_s_22w_w",
        },
        {
          image: "/F_44s_s_s",
        },
        {
          image: "/F_44s_s_w",
        },
        {
          image: "/F_44s_w_s",
        },
        {
          image: "/F_44s_w_w",
        },
        {
          image: "/F_44w_s_s",
        },
        {
          image: "/F_44w_s_w",
        },
        {
          image: "/F_44w_w_s",
        },
        {
          image: "/F_44w_w_w",
        },
      ],
      left: [
        {
          image: "/L_22s_door_22s",
        },
        {
          image: "/L_22s_door_22w",
        },
        {
          image: "/L_22s_w_door",
        },
        {
          image: "/L_22w_door_22s",
        },
        {
          image: "/L_22w_door_22w",
        },
        {
          image: "/L_22w_s_door",
        },
        {
          image: "/L_22w_w_door",
        },
        {
          image: "/L_44s_door",
        },
        {
          image: "/L_44w_door",
        },
        {
          image: "/L_door_22s_w",
        },
        {
          image: "/L_door_22w_s",
        },
        {
          image: "/L_door_22w_w",
        },
        {
          image: "/L_door_44s",
        },
        {
          image: "/L_door_44w",
        },
        {
          image: "/L_22s_w_s_44s",
        },
        {
          image: "/L_22s_w_s_w_s",
        },
        {
          image: "/L_22w_44s_s",
        },
        {
          image: "/L_22w_s_w_s_w",
        },
        {
          image: "/L_22w_w_s_44s",
        },
        {
          image: "/L_44s_22s_44s",
        },
        {
          image: "/L_44s_22s_44w",
        },
        {
          image: "/L_44s_22s_w_s",
        },
        {
          image: "/L_44s_22s_w_w",
        },
        {
          image: "/L_44s_22w_44s",
        },
        {
          image: "/L_44s_22w_44w",
        },
        {
          image: "/L_44s_s_22w",
        },
        {
          image: "/L_44w_22s_44s",
        },
        {
          image: "/L_44w_22s_44w",
        },
        {
          image: "/L_44w_22w_44s",
        },
        {
          image: "/L_44w_22w_44w",
        },
      ],
      right: [
        {
          image: "/R_22s_door_22s",
        },
        {
          image: "/R_22s_door_22w",
        },
        {
          image: "/R_22s_w_door",
        },
        {
          image: "/R_22w_door_22s",
        },
        {
          image: "/R_22w_door_22w",
        },
        {
          image: "/R_22w_s_door",
        },
        {
          image: "/R_22w_w_door",
        },
        {
          image: "/R_44s_door",
        },
        {
          image: "/R_44w_door",
        },
        {
          image: "/R_door_22s_w",
        },
        {
          image: "/R_door_22w_s",
        },
        {
          image: "/R_door_22w_w",
        },
        {
          image: "/R_door_44s",
        },
        {
          image: "/R_door_44w",
        },
        {
          image: "/R_22s_w_s_44s",
        },
        {
          image: "/R_22s_w_s_w_s",
        },
        {
          image: "/R_22w_44s_s",
        },
        {
          image: "/R_22w_s_w_s_w",
        },
        {
          image: "/R_22w_w_s_44s",
        },
        {
          image: "/R_44s_22s_44s",
        },
        {
          image: "/R_44s_22s_44w",
        },
        {
          image: "/R_44s_22s_w_s",
        },
        {
          image: "/R_44s_22s_w_w",
        },
        {
          image: "/R_44s_22w_44s",
        },
        {
          image: "/R_44s_22w_44w",
        },
        {
          image: "/R_44s_s_22w",
        },
        {
          image: "/R_44w_22s_44s",
        },
        {
          image: "/R_44w_22s_44w",
        },
        {
          image: "/R_44w_22w_44s",
        },
        {
          image: "/R_44w_22w_44w",
        },
      ],
    },
  },
];

let size = [
  {
    id: "eight",
    name: "8x8",
    totalSquareFootage: 8 * 8,
    length: 8,
    width: 8,
    price_per_sf: FLOORING_PSF,
    price: 5439.0,
  },
  {
    id: "ten",
    name: "10x8",
    totalSquareFootage: 10 * 8,
    length: 10,
    width: 8,
    price_per_sf: FLOORING_PSF,
    price: 6799.0,
  },
  {
    id: "twelve",
    name: "12x10",
    totalSquareFootage: 12 * 10,
    length: 12,
    width: 10,
    price_per_sf: FLOORING_PSF,
    price: 10199.0,
  },
];

let interior = [
  {
    id: "insulated_floor",
    name: "Insulated Floor",
    price_per_sf: "9.00",
  },
  {
    id: "insulated_wall",
    name: "Wall Insulation",
    price_per_sf: "1.40",
  },
  {
    id: "insulated_ceiling",
    name: "Ceiling Insulated",
    price_per_sf: "1.40",
  },
  {
    id: "pegboard_22",
    name: 'Interior Panels Pegboard 44"',
    price: "130.00",
  },
  {
    id: "pegboard_44",
    name: 'Interior Panels Pegboard 22"',
    price: "160.00",
  },
  {
    id: "beadboard_22",
    name: 'Interior Panels Beadboard 22"',
    price: "145.00",
  },
  {
    id: "beadboard_44",
    name: 'Interior Panels Beadboard 44"',
    price: "190.00",
  },
  {
    id: "panels_melamine",
    name: 'Interior Panels 5/8" Melamine',
    price: "160.00",
  },
  {
    id: "insulated_windows_22",
    name: 'Insulated Windows 22"',
    price: "175.00",
  },
  {
    id: "insulated_windows_44",
    name: 'Insulated Windows 44"',
    price: "450.00",
  },
];

let siding = [
  {
    id: "eight",
    name: "Lap Siding - 8 x 8",
    price: "832.00",
  },
  {
    id: "ten",
    name: "Lap Siding - 10 x 8",
    price: "1040.00",
  },
  {
    id: "twelve",
    name: "Lap Siding - 12 x 10",
    price: "1560.00",
  },
];

let services = [
  {
    id: "custom_design_base",
    name: "Custom Design Base Cost",
    price: "500.00",
  },
  {
    id: "local_delivery",
    name: "Local Delivery Cost",
    price: "350.00",
  },
  {
    id: "local_installation",
    name: "Local Installation Cost",
    price: "700.00",
  },
  {
    id: "permit_drawing_support",
    name: "Permit Drawing Support Cost",
    price: "1500.00",
  },
];

let colors = [
  {
    id: "green",
    name: "Green",
    hexcode: "#c8e4c5",
  },
  {
    id: "juneberry",
    name: "Juneberry",
    hexcode: "#864258",
  },
  {
    id: "naval",
    name: "Naval",
    hexcode: "#2e3d4c",
  },
  {
    id: "mysticshade",
    name: "Mystic Shade",
    hexcode: "#b0aaab",
  },
  {
    id: "rockcandy",
    name: "Rock Candy",
    hexcode: "#dee2e0",
  },
  {
    id: "sand",
    name: "Sand",
    hexcode: "#d4c5ba",
  },
  {
    id: "sleepyblue",
    name: "Sleepy Blue",
    hexcode: "#bacacc",
  },
  {
    id: "software",
    name: "Software",
    hexcode: "#808586",
  },
  {
    id: "tassel",
    name: "Tassel",
    hexcode: "#c78945",
  },
];

export let selectedConfigs = {
  eightSelectedConfigs: {
    F: "F_22s_door",
    B: "B_44s_s",
    L: "L_44s_s",
    R: "R_44s_s",
  },

  tenSelectedConfigs: {
    F: "F_22s_door_22s",
    B: "B_44s_22s_44s",
    L: "L_44s_s",
    R: "R_44s_s",
  },

  twelveSelectedConfigs: {
    F: "F_22s_door_44s",
    B: "B_44s_s_s",
    L: "L_44s_22s_44s",
    R: "R_44s_22s_44s",
  },
};

export function getColorOptions() {
  return colors;
}

export const getColorPrice = (key) => {
  return colors.filter((option) => {
    if (option.id === key) {
      return option.price;
    }
  });
};

export function getServicesOptions() {
  return services;
}

export const getServicesPrice = (key) => {
  return services.filter((option) => {
    if (option.id === key) {
      return option.price;
    }
  });
};

export function getSidingOptions() {
  return siding;
}

export const getSidingPrice = (key, fixed) => {
  return siding.filter((option) => {
    if (option.id === key) {
      if (fixed) {
        return option.price_per_sf;
      } else {
        return option.price;
      }
    }
  });
};

export function getInteriorOptions() {
  return interior;
}

export const getInteriorPrice = (key, fixed) => {
  return interior.filter((option) => {
    if (option.id === key) {
      if (fixed) {
        return option.price_per_sf;
      } else {
        return option.price;
      }
    }
  });
};

export function getFlooringPrice(length, width) {
  return length * width * FLOORING_PSF;
}

export function getSizeOptions() {
  return size;
}

//Fixed is a bool denoting if it is fixed price. False if psf
export const getExteriorPrice = (key, fixed) => {
  return exterior.filter((option) => {
    if (option.id === key) {
      if (fixed) {
        return option.price_per_sf;
      } else {
        return option.price;
      }
    }
  });
};

export function getExteriorOptions() {
  return exterior;
}

export function returnPricingOfSize(sizing) {
  return exterior.filter((option) => {
    if (option.size === sizing) {
      return option.data;
      // return option.data;
    }
  });
}
